export const RECOMMENDATIONS = [
	"Referred to modules",
	"Referred to Coaching",
	"Referred to GP",
	"Referred to University Services",
	"Referred to Emergency Services",
	"Book another session",
	"Other"
]
